import 'autotrack/autotrack.js';
import Keys from 'keys/keys.js';

const ga = window.ga;

ga('create', Keys.GA_TRACKING_ID, 'auto');

ga('require', 'eventTracker');
ga('require', 'outboundLinkTracker');
ga('require', 'urlChangeTracker');

ga('send', 'pageview');

export default ga;



// WEBPACK FOOTER //
// ./src/analytics.js